import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=23677cd7&scoped=true"
import script from "./SurveyResults.vue?vue&type=script&lang=js"
export * from "./SurveyResults.vue?vue&type=script&lang=js"
import style0 from "./SurveyResults.vue?vue&type=style&index=0&id=23677cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23677cd7",
  null
  
)

export default component.exports